import styled from 'styled-components';

export const ScanContainer = styled.div`
  position: absolute;
  width: 100%;
  min-height: 100vh;
  color: ${Styles.color.white};
  background-color: ${Styles.color.primary};
  padding: 0 1rem;
  ${Styles.desktop`
    padding-top: 150px;
    position: relative;
    & > div {
      max-width: 420px;
      margin: auto;
    }
  `}
`;
